import script from "./RegisterProject.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterProject.vue?vue&type=script&setup=true&lang=js"

import "./RegisterProject.vue?vue&type=style&index=0&id=24a5c924&scoped=true&lang=css"
import "./RegisterProject.vue?vue&type=style&index=1&id=24a5c924&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24a5c924"]])

export default __exports__